// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3dB_P","label":"Labeled_label__r7BU5","divider":"Labeled_divider__wtLro"};